<template>
  <div class="contact-page">
    <!-- Banner -->
    <div class="page-banner">
      <div class="banner-inner">
        <h1>{{ $t('footer.contact') }}</h1>
        <p>Contact Us</p>
      </div>
    </div>

    <div class="page-content">
      <!-- 联系信息卡片 -->
      <div class="contact-grid">
        <div class="contact-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>办公地址</h3>
          <p>北京市朝阳区建国路 88 号<br/>SOHO 现代城 A 座 1201</p>
          <p class="en">88 Jianguo Road, Chaoyang District<br/>Beijing, China 100022</p>
        </div>

        <div class="contact-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="22,6 12,13 2,6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>电子邮件</h3>
          <p><a href="mailto:support@nbcfa.com">support@nbcfa.com</a></p>
          <p><a href="mailto:business@nbcfa.com">business@nbcfa.com</a></p>
          <p class="en">Working hours: Mon–Fri 9:00–18:00 (CST)</p>
        </div>

        <div class="contact-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3>服务热线</h3>
          <p>400-888-NBCF（6223）</p>
          <p class="en">+86 10 8888 6223</p>
          <p class="en">Mon–Fri 9:00–18:00 (CST)</p>
        </div>

        <div class="contact-card">
          <div class="card-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <h3>在线客服</h3>
          <p>工作日 9:00–18:00 在线</p>
          <p class="en">Live chat available on our website</p>
          <button class="chat-btn">开始在线咨询</button>
        </div>
      </div>

      <!-- 留言表单 -->
      <div class="contact-form-section">
        <h2>发送留言</h2>
        <p class="form-sub">填写以下信息，我们将在 1-2 个工作日内回复您</p>
        <form class="contact-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input v-model="form.name" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>邮箱 <span class="required">*</span></label>
              <input v-model="form.email" type="email" placeholder="请输入您的邮箱" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>联系电话</label>
              <input v-model="form.phone" placeholder="选填" />
            </div>
            <div class="form-group">
              <label>咨询类型 <span class="required">*</span></label>
              <select v-model="form.type" required>
                <option value="">请选择</option>
                <option value="test">测评相关</option>
                <option value="report">报告/成绩单</option>
                <option value="account">账号问题</option>
                <option value="business">商务合作</option>
                <option value="other">其他</option>
              </select>
            </div>
          </div>
          <div class="form-group full">
            <label>留言内容 <span class="required">*</span></label>
            <textarea v-model="form.message" rows="5" placeholder="请描述您的问题或需求..." required></textarea>
          </div>
          <div class="form-actions">
            <button type="submit" class="submit-btn" :disabled="submitting">
              {{ submitting ? '提交中...' : '提交留言' }}
            </button>
          </div>
          <p class="success-msg" v-if="submitted">✅ 留言提交成功！我们将尽快回复您。</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      form: { name: '', email: '', phone: '', type: '', message: '' },
      submitting: false,
      submitted: false
    }
  },
  methods: {
    async submitForm() {
      this.submitting = true
      // 模拟提交延迟
      await new Promise(resolve => setTimeout(resolve, 800))
      this.submitting = false
      this.submitted = true
      this.form = { name: '', email: '', phone: '', type: '', message: '' }
    }
  }
}
</script>

<style scoped>
.contact-page { background: #f0f2f5; min-height: 100vh; }

/* Banner */
.page-banner {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%);
  padding: 60px 0 50px;
}
.banner-inner { max-width: 1100px; margin: 0 auto; padding: 0 40px; }
.banner-inner h1 { color: #fff; font-size: 32px; font-weight: 800; margin: 0 0 8px; }
.banner-inner p { color: #94a3b8; font-size: 14px; margin: 0; }

/* Content */
.page-content { max-width: 1100px; margin: 0 auto; padding: 40px 40px 60px; }

/* Contact Cards */
.contact-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 48px;
}
.contact-card {
  background: #fff;
  border-radius: 12px;
  padding: 28px 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  text-align: center;
}
.card-icon {
  width: 48px;
  height: 48px;
  background: #eff6ff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  color: #2b7de9;
}
.card-icon svg { width: 24px; height: 24px; }
.contact-card h3 { font-size: 15px; font-weight: 700; color: #1a1a1a; margin: 0 0 10px; }
.contact-card p { font-size: 13px; color: #555; margin: 0 0 6px; line-height: 1.6; }
.contact-card p.en { color: #888; font-size: 12px; }
.contact-card a { color: #2b7de9; text-decoration: none; }
.contact-card a:hover { text-decoration: underline; }
.chat-btn {
  margin-top: 12px;
  background: #2b7de9;
  color: #fff;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  font-weight: 600;
}
.chat-btn:hover { background: #1a6ad4; }

/* Form Section */
.contact-form-section {
  background: #fff;
  border-radius: 12px;
  padding: 40px 48px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}
.contact-form-section h2 { font-size: 22px; font-weight: 700; color: #1a1a1a; margin: 0 0 8px; }
.form-sub { font-size: 14px; color: #888; margin: 0 0 28px; }
.form-row { display: flex; gap: 24px; margin-bottom: 20px; }
.form-group { flex: 1; margin-bottom: 0; }
.form-group.full { margin-bottom: 20px; }
.form-group label { display: block; font-size: 13px; font-weight: 600; color: #444; margin-bottom: 6px; }
.required { color: #ef4444; }
.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  background: #fff;
  resize: vertical;
  font-family: inherit;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus { border-color: #2b7de9; }
.form-actions { text-align: center; margin-top: 8px; }
.submit-btn {
  background: #2b7de9;
  color: #fff;
  border: none;
  padding: 12px 56px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.submit-btn:hover { background: #1a6ad4; }
.submit-btn:disabled { background: #93bff0; cursor: not-allowed; }
.success-msg { text-align: center; color: #059669; font-size: 14px; font-weight: 600; margin-top: 16px; }

@media (max-width: 900px) {
  .contact-grid { grid-template-columns: repeat(2, 1fr); }
  .contact-form-section { padding: 28px 20px; }
}
@media (max-width: 600px) {
  .contact-grid { grid-template-columns: 1fr; }
  .form-row { flex-direction: column; }
  .page-content { padding: 24px 16px 40px; }
  .banner-inner { padding: 0 16px; }
}
</style>
